(() => {
  'use strict';
  const cfg = window.MarrakecheTheme || {};
  const root = cfg.root || '/';
  const path = (p) => `${root.replace(/\/$/, '')}/${p.replace(/^\//, '')}`;
  const $ = (s, scope = document) => scope.querySelector(s);
  const $$ = (s, scope = document) => [...scope.querySelectorAll(s)];
  const money = (amountInCents, currency = cfg.currency || 'USD') => {
    try { return new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency }).format(amountInCents / 100); }
    catch (_) { return `${(amountInCents / 100).toFixed(2)} ${currency}`; }
  };
  const escapeHTML = str => String(str ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let toastTimer;
  function toast(message) {
    const el = $('#toast'); if (!el) return;
    el.textContent = message; el.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('show'), 2800);
  }
  const menu = $('#mainNav'), menuButton = $('[data-menu-toggle]');
  menuButton?.addEventListener('click', () => {
    const expanded = menu.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(expanded));
  });
  $$('[data-search-toggle]').forEach(button => button.addEventListener('click', () => {
    const search = $('[data-search-bar]'); if (!search) return;
    const opened = search.classList.toggle('open');
    button.setAttribute('aria-expanded', String(opened));
    if (opened) $('input[type=search]', search)?.focus();
  }));
  const drawer = $('#cartDrawer'), shade = $('#cartShade');
  let lastFocus = null;
  function openDrawer() {
    if (!drawer || !shade) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    shade.hidden = false; requestAnimationFrame(() => shade.classList.add('show'));
    document.body.classList.add('locked'); $('[data-cart-close]')?.focus();
    refreshCart();
  }
  function closeDrawer() {
    if (!drawer || !shade) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
    shade.classList.remove('show'); document.body.classList.remove('locked');
    setTimeout(() => { shade.hidden = true; }, 240);
    lastFocus?.focus?.();
  }
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openDrawer));
  $('[data-cart-close]')?.addEventListener('click', closeDrawer);
  shade?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeDrawer(); menu?.classList.remove('open');
      menuButton?.setAttribute('aria-expanded', 'false');
      $('[data-search-bar]')?.classList.remove('open');
    }
    if (e.key === 'Tab' && drawer?.classList.contains('open')) {
      const focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])', drawer);
      if (focusables.length === 0) return;
      if (e.shiftKey && document.activeElement === focusables[0]) { e.preventDefault(); focusables[focusables.length - 1].focus(); }
      if (!e.shiftKey && document.activeElement === focusables[focusables.length - 1]) { e.preventDefault(); focusables[0].focus(); }
    }
  });
  async function jsonFetch(url, options) {
    const response = await fetch(url, {credentials:'same-origin', ...options});
    let data; try { data = await response.json(); } catch (_) { data = {}; }
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again');
    return data;
  }
  async function refreshCart() {
    try {
      const cart = await jsonFetch(path('cart.js'));
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      const countLabel = $('[data-cart-count-label]'); if (countLabel) countLabel.textContent = `(${cart.item_count})`;
      const total = $('[data-cart-total]'); if (total) total.textContent = money(cart.total_price, cart.currency);
      const itemsEl = $('[data-cart-items]'); if (!itemsEl) return;
      if (!cart.items?.length) { itemsEl.innerHTML = '<p class="empty-bag">Your bag is empty.<br><span>Browse our leather bags.</span></p>'; return; }
      itemsEl.innerHTML = cart.items.map(item => {
        const img = item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy">` : '';
        const name = escapeHTML(item.product_title);
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHTML(item.variant_title)}</small>` : '';
        return `<div class="drawer-item">${img}<div><h3>${name}</h3>${variant}<p>${money(item.final_line_price, cart.currency)}</p><div class="drawer-qty"><button type="button" data-cart-line="${item.key}" data-change="${item.quantity - 1}" aria-label="Decrease quantity for ${name}">−</button><span>${item.quantity}</span><button type="button" data-cart-line="${item.key}" data-change="${item.quantity + 1}" aria-label="Increase quantity for ${name}">+</button></div></div><button type="button" data-cart-line="${item.key}" data-change="0" class="remove-item">Remove</button></div>`;
      }).join('');
    } catch (error) { console.warn('Cart unavailable:', error); }
  }
  drawer?.addEventListener('click', async e => {
    const button = e.target.closest('[data-cart-line]'); if (!button) return;
    button.disabled = true;
    try { await jsonFetch(path('cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.cartLine,quantity:Number(button.dataset.change)})}); await refreshCart(); }
    catch (error) { toast(error.message); button.disabled = false; }
  });
  $$('.product-form').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = $('[data-add-button]', form); if (!button || button.disabled) return;
    const message = $('[data-form-message]', form);
    button.disabled = true; const oldText = button.textContent; button.textContent = 'Adding…';
    try {
      const data = new FormData(form);
      await jsonFetch(path('cart/add.js'), {method:'POST',body:data});
      if (message) message.textContent = 'Added to your bag.';
      toast('Added to your bag'); openDrawer();
    } catch (error) {
      if (message) message.textContent = error.message;
      toast(error.message);
    } finally { button.disabled = false; button.textContent = oldText; }
  }));
  $$('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const info = select.closest('.product-info');
    const price = $('[data-product-price]', info);
    const button = $('[data-add-button]', info);
    if (price) price.textContent = option.dataset.price || '';
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to bag'; }
    const u = new URL(window.location.href); u.searchParams.set('variant', option.value); history.replaceState({}, '', u);
  }));
  $$('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
    const img = $('[data-main-image] img'); if (!img) return;
    img.src = button.dataset.gallerySrc; img.removeAttribute('srcset');
    img.alt = button.dataset.galleryAlt || '';
    $$('.thumb-btn').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  refreshCart();
})();
